import { requestData } from "./utils";

interface SMSConfig {
  default_account_throttle_max_mt_per_second: number;
  default_account_throttle_max_mo_per_second: number;
  max_length_of_text_message: number;
  max_length_of_unicode_message: number;
}

export interface CheckMessageLengthParams {
  from: string;
  to: string;
  message_type: string;
  delivery_receipts: { required: boolean };
  text_message: { text: string };
}

export interface CheckMessageLengthResponse {
  message_length: number;
  how_many_message_parts: number;
  max_permitted_length: number;
  acceptable: boolean;
  auto_detected_unicode?: boolean;
}
export default class SmbModule {
  send(data) {
    return requestData("POST", "/sms/submit", data);
  }

  getConfig() {
    return requestData<SMSConfig>("GET", "/sms/smsConfig");
  }

  checkMessageLength(payload: CheckMessageLengthParams) {
    return requestData<CheckMessageLengthResponse>(
      "POST",
      "/sms/check-message-length",
      payload,
    );
  }
}
